module.exports = __webpack_public_path__ + "img/parent-cat-6.faee6928.svg";